import {

    SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES,
    SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES_EXITO,
    SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES_ERROR,

    PREPARAR_EXPORTACION_HISTORIA_CLINICA,
    PREPARAR_EXPORTACION_HISTORIA_CLINICA_EXITO,
    PREPARAR_EXPORTACION_HISTORIA_CLINICA_ERROR,

    EXPORTAR_HISTORIAS_CLINICAS,
    EXPORTAR_HISTORIAS_CLINICAS_EXITO,
    EXPORTAR_HISTORIAS_CLINICAS_ERROR

} from '../types';


import clienteAxios from '../config/axios';


/*
====================================
SOLICITAR HISTORIAS CLÍNICAS
EXPORTABLES
====================================
*/

export function solicitarHistoriasClinicasExportablesAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        dispatch(
            solicitarHistoriasClinicasExportables()
        );


        try {

            const {
                config,
                payload
            } = informacion;


            const {
                data
            } = await clienteAxios.post(

                '/paciente/buscarhistoriasclinicasexportables',

                payload || {},

                config

            );


            dispatch(
                solicitarHistoriasClinicasExportablesExito(
                    data || {
                        scope: null,
                        pacientes: []
                    }
                )
            );


            return {

                ok:
                    true,

                data:
                    data || {
                        scope: null,
                        pacientes: []
                    }

            };


        } catch (
            error
        ) {

            const mensajeError =

                error?.response?.data ||

                {
                    msg:
                        'No se pudieron obtener las historias clínicas disponibles para exportar.'
                };


            dispatch(
                solicitarHistoriasClinicasExportablesError(
                    mensajeError
                )
            );


            return {

                ok:
                    false,

                error:
                    mensajeError

            };

        }

    };

}


const solicitarHistoriasClinicasExportables = () => ({

    type:
        SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES,

    payload:
        true

});


const solicitarHistoriasClinicasExportablesExito = (
    data
) => ({

    type:
        SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES_EXITO,

    payload:
        data

});


const solicitarHistoriasClinicasExportablesError = (
    msg
) => ({

    type:
        SOLICITAR_HISTORIAS_CLINICAS_EXPORTABLES_ERROR,

    payload:
        msg

});


/*
====================================
PREPARAR EXPORTACIÓN
====================================

El backend vuelve a validar:

- rol;
- contraseña del profesional;
- paciente;
- pertenencia del paciente;
- período;
- existencia real de HC;
- fechas no futuras.

Cada item tiene esta forma:

{
    paciente_id_interno: 6,
    periodo: '2026-08'
}
====================================
*/

export function prepararExportacionHistoriaClinicaAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        dispatch(
            prepararExportacionHistoriaClinica()
        );


        try {

            const {
                config,
                payload
            } = informacion;


            const {
                data
            } = await clienteAxios.post(

                '/paciente/prepararexportacionhistoriaclinica',

                payload,

                config

            );


            dispatch(
                prepararExportacionHistoriaClinicaExito(
                    data
                )
            );


            /*
            ====================================
            DEVOLVEMOS RESULTADO AL COMPONENTE
            ====================================

            Esto nos permite decidir si cerramos
            el modal o mostramos el error de
            contraseña sin llamar a Axios desde
            el componente.
            ====================================
            */

            return {

                ok:
                    true,

                data

            };


        } catch (
            error
        ) {

            const mensajeError =

                error?.response?.data ||

                {
                    msg:
                        'No se pudo preparar la exportación.'
                };


            dispatch(
                prepararExportacionHistoriaClinicaError(
                    mensajeError
                )
            );


            return {

                ok:
                    false,

                error:
                    mensajeError

            };

        }

    };

}


/*
====================================
PREPARAR - SOLICITO
====================================
*/

const prepararExportacionHistoriaClinica = () => ({

    type:
        PREPARAR_EXPORTACION_HISTORIA_CLINICA,

    payload:
        true

});


/*
====================================
PREPARAR - ÉXITO
====================================
*/

const prepararExportacionHistoriaClinicaExito = (
    data
) => ({

    type:
        PREPARAR_EXPORTACION_HISTORIA_CLINICA_EXITO,

    payload:
        data

});


/*
====================================
PREPARAR - ERROR
====================================
*/

const prepararExportacionHistoriaClinicaError = (
    msg
) => ({

    type:
        PREPARAR_EXPORTACION_HISTORIA_CLINICA_ERROR,

    payload:
        msg

});

/*
====================================
EXPORTAR HISTORIAS CLÍNICAS
====================================

Genera el ZIP real.

El backend vuelve a validar:

- rol;
- contraseña;
- pacientes;
- períodos;
- pertenencia;
- historias clínicas reales.

La respuesta es binaria:
application/zip
====================================
*/

export function exportarHistoriasClinicasAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        dispatch(
            exportarHistoriasClinicas()
        );


        try {

            const {
                config,
                payload
            } = informacion;


            const respuesta =
                await clienteAxios.post(

                    '/paciente/exportarhistoriasclinicas',

                    payload,

                    {

                        ...config,

                        responseType:
                            'blob'

                    }

                );


            /*
            ====================================
            NOMBRE DEL ARCHIVO
            ====================================

            Intentamos leerlo del header.

            Si el navegador / CORS no expone
            Content-Disposition, usamos un
            nombre seguro de respaldo.
            ====================================
            */

            const contentDisposition =

                respuesta?.headers?.[
                    'content-disposition'
                ] ||

                respuesta?.headers?.[
                    'Content-Disposition'
                ] ||

                '';


            let nombreArchivo =
                'historias_clinicas.zip';


            const coincidenciaNombre =
                contentDisposition.match(
                    /filename="?([^"]+)"?/i
                );


            if (
                coincidenciaNombre?.[1]
            ) {

                nombreArchivo =
                    coincidenciaNombre[1]
                        .trim();

            }


            const blob =
                respuesta.data;


            dispatch(
                exportarHistoriasClinicasExito({

                    nombreArchivo,

                    tamanio_bytes:
                        blob?.size ||
                        null

                })
            );


            return {

                ok:
                    true,

                blob,

                nombreArchivo

            };


        } catch (
            error
        ) {

            /*
            ====================================
            ERROR CON RESPONSE TYPE BLOB
            ====================================

            Como pedimos blob, un error JSON
            del backend también puede llegar
            convertido en Blob.

            Intentamos recuperar el mensaje.
            ====================================
            */

            let mensajeError = {

                msg:
                    'No se pudo generar la exportación de historias clínicas.'

            };


            try {

                const dataError =
                    error?.response?.data;


                if (
                    dataError instanceof Blob
                ) {

                    const texto =
                        await dataError.text();


                    if (
                        texto
                    ) {

                        const json =
                            JSON.parse(
                                texto
                            );


                        mensajeError =
                            json;

                    }

                } else if (
                    dataError
                ) {

                    mensajeError =
                        dataError;

                }

            } catch (
                errorLectura
            ) {

                /*
                Si no podemos interpretar
                el error, mantenemos el
                mensaje genérico.
                */

            }


            dispatch(
                exportarHistoriasClinicasError(
                    mensajeError
                )
            );


            return {

                ok:
                    false,

                error:
                    mensajeError

            };

        }

    };

}


/*
====================================
EXPORTAR - SOLICITO
====================================
*/

const exportarHistoriasClinicas = () => ({

    type:
        EXPORTAR_HISTORIAS_CLINICAS,

    payload:
        true

});


/*
====================================
EXPORTAR - ÉXITO
====================================
*/

const exportarHistoriasClinicasExito = (
    data
) => ({

    type:
        EXPORTAR_HISTORIAS_CLINICAS_EXITO,

    payload:
        data

});


/*
====================================
EXPORTAR - ERROR
====================================
*/

const exportarHistoriasClinicasError = (
    msg
) => ({

    type:
        EXPORTAR_HISTORIAS_CLINICAS_ERROR,

    payload:
        msg

});